import { render, staticRenderFns } from "./ProcurementList.vue?vue&type=template&id=809dcac8&scoped=true"
import script from "./ProcurementList.vue?vue&type=script&lang=js"
export * from "./ProcurementList.vue?vue&type=script&lang=js"
import style0 from "./ProcurementList.vue?vue&type=style&index=0&id=809dcac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809dcac8",
  null
  
)

export default component.exports